// GTM integration with Turbo navigation
// Ensures page_view events are tracked correctly during Turbo navigation

document.addEventListener('turbo:load', (event) => {
  // Ignore Turbo previews (cache restoration) to avoid duplicate tracking
  if (document.documentElement.hasAttribute("data-turbo-preview")) {
    return;
  }

  // Push a virtual page view on EVERY load (including initial)
  // We use a small timeout to ensure the document title has been updated
  setTimeout(() => {
    if (typeof window.dataLayer !== 'undefined') {
      console.log("[GTM] Tracking Turbo Page View:", window.location.pathname);
      window.dataLayer.push({
        event: 'turbo_page_view',
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
        page_location: window.location.href,
        original_location: event.detail?.url || window.location.href
      });
    }
  }, 100);
});
